import { render, staticRenderFns } from "./Gr.vue?vue&type=template&id=07e7d0c8&scoped=true&"
import script from "./Gr.vue?vue&type=script&lang=js&"
export * from "./Gr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7d0c8",
  null
  
)

export default component.exports